import * as UH from './../util/UrlHttp'
import axios from 'axios'

export const GetRanking = async (data:any) => {

    return await axios.post(`${UH.BASE_URL}ranking/`, data, UH.HEADER_HTTP_TOKEN)
                .then(function (response) {
                    return response;
                })
                .catch(function (error) {
                    return error;
                });
}

export const GetPositionUser = async (id:any) => {

    return await axios.get(`${UH.BASE_URL}ranking/${id}`, UH.HEADER_HTTP_TOKEN)
                .then(function (response) {
                    return response;
                })
                .catch(function (error) {
                    return error;
                });
}





